import React, { Component } from "react";
import {
  Container,
  Card,
  CardHeader,
  Button,
  CardBody,
  Row,
  Col,
  Table,
  Badge,
} from "reactstrap";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";

import { MDBDataTableV5, MDBBadge } from "mdbreact";
import moment from "moment";
import GetPIDetails from "../../GetPIDetails";
import ItemDetails from "../../ItemDetails";
import LoadingModel from "../../LoadingModel";

import "./RequestForQuotation.scss";

import {
  getRFQRequestdata,
  getVendorsList,
  ClearVendors,
  addVendors,
  PIDetailsModel_open,
  getMRCodeDetails,
  addVendorsModelOpen,
} from "../../../store/RequetForQuotation/actions";
import copy from "copy-to-clipboard";
import { MRDetailsModel_open } from "../../../store/PurchaseIndent/actions";
import GetMRDetails from "../../GetMRDetails";
import AddVendorModel from "../AddVendorModel";
import GetMRPIDetails from "../../GetMRPIDetails";

class RequestForQuotation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      item_details: {},
      search: "",
      now: moment(),
    };
    this.toggleTab = this.toggleTab.bind(this);
    this.tog_static = this.tog_static.bind(this);
  }
  tog_static(row) {
    this.setState((prevState) => ({
      modal_static: !prevState.modal_static,
      item_details: row,
    }));
    // this.props.getMRCodeDetails(row.id);

    this.removeBodyCss();
  }

  removeBodyCss() {
    document.body.classList.add("no_padding");
  }
  toggleTab(tab) {
    if (this.state.activeTab !== tab) {
      if (tab >= 1 && tab <= 2) {
        this.setState({
          activeTab: tab,
        });
      }
    }
  }

  componentDidMount() {
    const {
      match: { params },
    } = this.props;
    // this.props.getVendors();
    this.props.getRFQRequestdata(params.id);
    setInterval(() => {
      this.setState({
        now: moment(),
      });
    }, 1000);
  }

  GetVendorslist() {
    this.toggleTab(1);
    this.removeBodyCss();
    this.props.addVendorsModelOpen(this.props.match.params.id);
    // this.props.getVendorsList({}, true);
  }

  getVendorLink(vendToken) {
    copy(localStorage.getItem("BaseURL") + "/vendorlogin/" + vendToken);

    const Toast = Swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.addEventListener("mouseenter", Swal.stopTimer);
        toast.addEventListener("mouseleave", Swal.resumeTimer);
      },
    });

    Toast.fire({
      icon: "success",
      title: "Vendor Quotation link Copied",
    });
  }
  GetLiveTime(startDate) {
    var ms = this.state.now.diff(moment(startDate));
    var d = moment.duration(ms);
    var mmss = moment.utc(ms).format("mm");
    return Math.floor(d.asHours()) + " Hrs " + mmss + " mm";
  }
  GetDuraction(startDate, EndDate) {
    var ms = moment(EndDate).diff(moment(startDate));
    var d = moment.duration(ms);
    var mmss = moment.utc(ms).format("mm:ss");
    return Math.floor(d.asHours()) + " Hrs " + mmss + " mm";
  }
  getResetQuotation(vendId) {
    Swal.fire({
      title: "Are you sure Reset Quotation ?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
    }).then((result) => {
      if (result.isConfirmed) {
        this.props.addVendors(
          { vendor_ids: [vendId], resend: 1 },
          this.props.match.params.id
        );
        this.props.getRFQRequestdata(this.props.match.params.id);
      }
    });
  }
  render() {
    var allitems = [];
    if (this.props.RFQrowdata && this.props.RFQrowdata.rfqitems) {
      allitems = this.props.RFQrowdata.rfqitems.map((row, order) => ({
        ...row,
        sno: (
          <MDBBadge color="primary" className="p-1 px-2">
            {order + 1}
          </MDBBadge>
        ),
        ItemName: (
          <div>
            <h5 className="font-size-14 text-truncate">
              <Link
                to="#"
                onClick={() => this.tog_static(row)}
                className="text-primary"
              >
                {/* <i className="mdi  mdi-magnify bg-success text-white"></i>{" "} */}
                <u> {row.product.name}</u>
              </Link>
            </h5>
          </div>
        ),
        GetMRDetails: (
          <>
            {row.mrdata?.mrcodes ? (
              <>
                {row.mrdata.mrcodes.length === 0 ? (
                  <>Not found</>
                ) : (
                  <>
                    <Link
                      to="#"
                      onClick={() => {
                        this.props.MRDetailsModel_open(
                          row.mrdata.mrcodes[0].id
                        );
                      }}
                      className="text-primary mr-1"
                    >
                      <u>{row.mrdata.mrcodes[0].code}</u>
                    </Link>
                  </>
                )}
              </>
            ) : (
              <>
                <Link
                  to="#"
                  onClick={() => {
                    this.props.getMRCodeDetails(row.id);
                  }}
                  className="text-primary mr-1"
                >
                  <u>View</u>
                </Link>
              </>
            )}
          </>
        ),
        GetPIDetail: (
          <>
            {row?.rfqipiis.length === 0 ? (
              <>
                <span>
                  {" "}
                  <u>View</u>
                </span>
              </>
            ) : (
              <Link
                to="#"
                onClick={() => {
                  this.props.PIDetailsModel_open(
                    row?.rfqipiis[row?.rfqipiis.length - 1].piitem
                      ?.purchaseindent_id
                  );
                }}
                className="text-primary mr-1"
              >
                <u>View</u>
              </Link>
            )}
          </>
        ),
        IndentQuantity: (
          <span className="font-weight-medium">
            {row.qty} {row.unit.name}
          </span>
        ),
        DateRequired: row.date,
        Department: row.product.department.name,
      }));
    }

    const Itemsdatatable = {
      columns: [
        {
          label: "S.No",
          field: "sno",
          sort: "disabled",
          width: 30,
        },

        {
          label: "Item Name",
          field: "ItemName",

          width: 150,
        },
        {
          label: "MR Details",
          field: "GetMRDetails",

          width: 150,
        },
        {
          label: "PI Details",
          field: "GetPIDetail",

          width: 150,
        },
        {
          label: "Indent Quantity",
          field: "IndentQuantity",

          width: 200,
        },
        {
          label: "Request Date",
          field: "DateRequired",

          width: 150,
        },
        {
          label: "Department",
          field: "Department",

          width: 150,
        },
      ],
      rows: allitems,
    };
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            {this.props.loading && (
              <LoadingModel OpenModel={this.props.loading} />
            )}

            <Row>
              <Col md={12}>
                <Card className="mb-0">
                  <CardHeader className="bg-transparent border-bottom ">
                    <Link
                      to="/rfqdashboard"
                      className="action-icon text-primary mr-2"
                    >
                      {" "}
                      <i className="mdi mdi-arrow-left-bold-circle-outline font-size-20"></i>
                    </Link>
                    <h5 className="card-title-18 pt-2 d-inline-block">
                      Request For Quotation{" "}
                      <span>(#{this.props.RFQrowdata.code})</span>
                    </h5>
                    <div className="float-right">
                      <div className="d-inline-block ">
                        <Link
                          to={"/rfqreportdoc/" + this.props.match.params.id}
                          className="action-icon text-primary mr-2"
                        >
                          <Button
                            type="button"
                            outline
                            color="secondary"
                            className=" mr-2"
                          >
                            <i className="mdi  mdi-printer"></i>
                            <span className="d-none d-inline-block ml-1">
                              Print
                            </span>
                          </Button>
                        </Link>
                      </div>
                    </div>
                  </CardHeader>
                  <CardBody className="pt-1  ">
                    <Row className="p-1 ">
                      <Col md={12} className="p-1 mb-0">
                        <Card className="p-1 mb-0 mt-0 ">
                          <CardBody className="pt-1 pb-0 mt-0 ">
                            <Row className="p-0">
                              <Col md={8} className="p-1 m-0">
                                <div className="Quotation-panel-content">
                                  <div className="list-column">
                                    <Row>
                                      <Col md={6}>
                                        <ul className="list-style-two p-0">
                                          <li className="clearfix">
                                            <span className="ttl">
                                              Request By:
                                            </span>
                                            <span className="dtl">
                                              {
                                                this.props.RFQrowdata?.createdby
                                                  ?.fullname
                                              }
                                            </span>
                                            {/* <span className="dtl">
                                              <ul className="user-column p-0">
                                                <li className="clearfix p-0 m-0">
                                                  <span className="img">
                                                    <img
                                                      className="img-fluid p-0"
                                                      src={
                                                        this.props.RFQrowdata
                                                          ?.createdby?.image ==
                                                        null
                                                          ? Defaultuser
                                                          : this.props
                                                              .RFQrowdata
                                                              ?.createdby?.image
                                                      }
                                                      alt="user"
                                                    />
                                                  </span>
                                                  <span className="userttl">
                                                    {
                                                      this.props.RFQrowdata
                                                        ?.createdby?.fullname
                                                    }
                                                  </span>
                                                </li>
                                              </ul>
                                            </span> */}
                                          </li>
                                        </ul>
                                      </Col>
                                      <Col md={6}>
                                        <ul className="list-style-two p-0">
                                          <li className="clearfix">
                                            <span className="ttl">
                                              Submited Date:
                                            </span>
                                            <span className="dtl">
                                              {this.props.RFQrowdata.createdon}
                                            </span>
                                          </li>
                                        </ul>
                                      </Col>
                                    </Row>
                                  </div>
                                </div>
                              </Col>
                              <Col md={4} className="p-0 mt-0">
                                <div className="float-right">
                                  <Button
                                    type="submit"
                                    color="primary"
                                    size="lg"
                                    disabled={
                                      this.props.RFQrowdata.rfqstatus === 3
                                    }
                                    className="waves-effect waves-light mr-2"
                                    onClick={() => {
                                      this.GetVendorslist();
                                    }}
                                  >
                                    <i className="mdi mdi-checkbox-marked-circle-outline mr-2"></i>
                                    Add Vendors
                                  </Button>
                                </div>
                                {/* <div className="CompareBox">
                                  <Button
                                    type="submit"
                                    color="success"
                                    size="lg"
                                    block
                                    className="waves-effect waves-light mr-2"
                                    href="/CompareQuotationDashboard"
                                  >
                                    <i className="mdi mdi-checkbox-marked-circle-outline mr-2"></i>
                                    Compare Quotation
                                  </Button>
                                </div> */}
                              </Col>
                            </Row>
                          </CardBody>
                        </Card>
                      </Col>
                      <Col md={12} className="p-1">
                        <Card className="p-1">
                          <CardBody className="pt-1 pb-0">
                            <Row>
                              <Col md={12}>
                                <h3 className="card-title-15 pt-2">
                                  Vendors List
                                </h3>
                                {/* <hr className="my-4" /> */}
                              </Col>
                            </Row>
                            <Row className="p-0">
                              <Col md={12} className="m-1">
                                <div className="table-responsive mt-2">
                                  <Table className="table-centered mb-0">
                                    <thead className="bg-light text-center ">
                                      <tr>
                                        <th style={{ width: "20px" }}>S.No</th>
                                        <th>Vendors Name</th>
                                        <th>Vendors Locations</th>
                                        <th>Vendors Email</th>
                                        <th>Vendor Add On</th>
                                        <th>Running TimeOut</th>
                                        <th>Quotation Status</th>
                                        <th>Quotation View</th>
                                        <th>Actions</th>
                                      </tr>
                                    </thead>
                                    <tbody className="text-center">
                                      {this.props.RFQrowdata?.rfqvendors !==
                                      0 ? (
                                        <>
                                          {this.props.RFQrowdata?.rfqvendors?.map(
                                            (vend, key) => (
                                              <tr>
                                                <td>{key + 1}</td>
                                                <td>{vend.vendor.name}</td>
                                                <td>{vend.vendor.city}</td>
                                                <td>{vend.vendor.email}</td>
                                                <td>
                                                  {moment(
                                                    vend.createdon
                                                  ).format(
                                                    "DD-MM-YYYY, h:mm:ss"
                                                  )}
                                                </td>
                                                <td>
                                                  {vend.loginstatus !== 2 ? (
                                                    <>
                                                      {moment
                                                        .duration(
                                                          moment().diff(
                                                            moment(
                                                              vend.createdon
                                                            )
                                                          )
                                                        )
                                                        .asHours() >=
                                                      this.props.RFQrowdata
                                                        .hr ? (
                                                        <>
                                                          <Badge
                                                            color="danger"
                                                            className="font-size-14"
                                                          >
                                                            Time Expired
                                                          </Badge>
                                                        </>
                                                      ) : (
                                                        <Badge
                                                          color="info"
                                                          className="font-size-14"
                                                        >
                                                          {" "}
                                                          {this.GetDuraction(
                                                            vend.createdon,
                                                            this.state.now
                                                          )}
                                                        </Badge>
                                                      )}
                                                    </>
                                                  ) : (
                                                    <>
                                                      <Badge
                                                        color="success"
                                                        className="font-size-14"
                                                      >
                                                        {" "}
                                                        {this.GetDuraction(
                                                          vend.createdon,
                                                          vend.quotation_createdon
                                                        )}
                                                      </Badge>
                                                    </>
                                                  )}
                                                </td>
                                                <td>
                                                  {vend.resend === true ? (
                                                    <Badge
                                                      color="pink"
                                                      className="font-size-14 "
                                                    >
                                                      Reset
                                                      {/* <i className="mdi mdi-clipboard-text font-size-18 "></i> */}
                                                    </Badge>
                                                  ) : (
                                                    <></>
                                                  )}
                                                </td>
                                                <td>
                                                  {vend.loginstatus === 2 ? (
                                                    <>
                                                      <Badge
                                                        color="primary"
                                                        className="font-size-14"
                                                      >
                                                        Submited
                                                        {/* <i className="mdi mdi-clipboard-text font-size-18 "></i> */}
                                                      </Badge>
                                                    </>
                                                  ) : (
                                                    <>
                                                      <Badge
                                                        color="primary"
                                                        className="font-size-14"
                                                      >
                                                        Not Submited
                                                      </Badge>
                                                    </>
                                                  )}
                                                </td>

                                                <td>
                                                  <>
                                                    {vend.loginstatus === 1 &&
                                                    moment
                                                      .duration(
                                                        moment().diff(
                                                          moment(vend.createdon)
                                                        )
                                                      )
                                                      .asHours() <
                                                      this.props.RFQrowdata
                                                        .hr ? (
                                                      <>
                                                        <Link
                                                          to="#"
                                                          disabled={true}
                                                          // onClick={() => {navigator.clipboard.writeText(vend.email)}}
                                                          onClick={() =>
                                                            this.getVendorLink(
                                                              vend.token
                                                            )
                                                          }
                                                        >
                                                          <i className="mdi mdi-content-copy font-size-18 "></i>
                                                        </Link>
                                                      </>
                                                    ) : (
                                                      <>
                                                        <Link
                                                          className="text-danger"
                                                          to="#"
                                                          disabled={true}
                                                          // onClick={() => {navigator.clipboard.writeText(vend.email)}}
                                                          onClick={() =>
                                                            this.getResetQuotation(
                                                              vend.vendor.id
                                                            )
                                                          }
                                                        >
                                                          <i className="mdi mdi-restore font-size-18 "></i>
                                                        </Link>
                                                      </>
                                                    )}
                                                  </>
                                                  <>
                                                    {vend.loginstatus === 2 ? (
                                                      <>
                                                        <Link
                                                          to={
                                                            "/Quotation/" +
                                                            vend.quotation
                                                          }
                                                        >
                                                          <i className="mdi mdi-eye font-size-18 ml-2"></i>
                                                        </Link>
                                                      </>
                                                    ) : (
                                                      <>
                                                        <i className="mdi mdi-eye-off font-size-18  ml-2"></i>
                                                        {/* <Badge
                                                          color="primary"
                                                          className="font-size-14"
                                                        >
                                                          Not Submited
                                                        </Badge> */}
                                                      </>
                                                    )}
                                                  </>
                                                </td>
                                              </tr>
                                            )
                                          )}
                                        </>
                                      ) : (
                                        <tr>
                                          <td colSpan={6}>
                                            <div className="text-center">
                                              <span className="font-size-18 text-danger">
                                                Vendors not available
                                              </span>
                                            </div>
                                          </td>
                                        </tr>
                                      )}
                                    </tbody>
                                  </Table>
                                </div>
                                {/* <MDBDataTableV5
                                  maxHeight="100px"
                                  responsive
                                  striped
                                  entriesOptions={[5, 20, 25]}
                                  entries={5}
                                  pagesAmount={4}
                                  fullPagination
                                  data={Vendorsdatatable}
                                  searchBottom={false}
                                /> */}
                              </Col>
                            </Row>
                          </CardBody>
                        </Card>
                      </Col>

                      <Col md={12} className="p-1">
                        <Card className="p-1">
                          <CardBody className="pt-1 pb-0">
                            <Row>
                              <Col md={12}>
                                <h3 className="card-title-15 pt-2">
                                  Items List
                                </h3>
                                {/* <hr className="my-4" /> */}
                              </Col>
                            </Row>
                            <Row className="p-0">
                              <Col md={12} className="m-1">
                                <MDBDataTableV5
                                  hover
                                  maxHeight="100px"
                                  responsive
                                  striped
                                  entriesOptions={[5, 20, 25]}
                                  entries={5}
                                  pagesAmount={4}
                                  fullPagination
                                  data={Itemsdatatable}
                                  searchBottom={false}
                                />
                              </Col>
                            </Row>
                          </CardBody>
                        </Card>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            </Row>
            {/* MODEL FOR PRODUCT VENDER DETAILS */}
            {this.props.addVendorsModel && <AddVendorModel />}
            <GetMRPIDetails />
            <GetMRDetails />
            <ItemDetails
              modelOpen={this.state.modal_static}
              item={this.state.item_details}
              ItemLevel="RFQLevel"
              modelClose={() => {
                this.setState({ modal_static: false });
              }}
            />
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = (state) => {
  const {
    RFQrowdata,
    vendorslist,
    RFQSelectVendors,
    vendordata,
    loading,
    addVendorsModel,
  } = state.RequestForQuotation;
  return {
    RFQrowdata,
    vendorslist,
    RFQSelectVendors,
    vendordata,
    loading,
    addVendorsModel,
  };
};

export default connect(mapStatetoProps, {
  getVendorsList,
  getRFQRequestdata,
  ClearVendors,
  addVendors,
  PIDetailsModel_open,
  getMRCodeDetails,
  MRDetailsModel_open,
  addVendorsModelOpen,
})(RequestForQuotation);
